module.exports = __webpack_public_path__ + "img/pauli-x-root-34.0e175a64.svg";